import request from 'manager/utils/request';
import { REST_SERVICE } from 'manager/config';

const businessService = {
  // 导出功能
  exportModel(params) {
    console.log(params, 77777);
    window.open(REST_SERVICE.business.getApplyZipExport + '?wwywh=' + params);
  },

  //查询预审列表
  queryYsList(params) {
    return request({
      url: REST_SERVICE.business.queryYsList,
      method: 'get',
      params,
    });
  },
  // 打印申请表
  printApply(params) {
    return request({
      url: REST_SERVICE.business.printApply,
      method: 'post',
      params,
    });
  },
  // 打印受理凭证
  estatePrintApply(params) {
    return request({
      url: REST_SERVICE.business.estatePrintApply,
      method: 'post',
      params,
    });
  },
  //获取申请详情
  getProcessInfo(params) {
    return request({
      url: REST_SERVICE.business.getProcessInfo,
      method: 'get',
      params,
    });
  },
  //返回是否超期对应html
  //sfcq 是否超期的值
  getSfcqHtml(sfcq) {
    let html = '';
    switch (sfcq) {
      case '0':
        html += '<span style="display:inline-block;color:red;">已超期</span>';
        break;
      case '1':
        html += '<span style="display:inline-block;color:#fee107">即将超期</span>';
        break;
      default:
        html += '<span style="display:inline-block;color:#00ff00">正常</span>';
        break;
    }
    if (!sfcq) {
      html = '<span style="display:inline-block;color:#606266">---</span>';
    }
    return html;
  },

  addWorkdays(startDate, step, ywh) {
    const day = ywh.startsWith('WW') || ywh.startsWith('WG-DY') ? 5 : ywh.startsWith('WG-JY') ? 1 : 5; // 默认值
    let html = '';
    const holidays2025 = [
      // 元旦[citation:1]
      '2025-01-01',
      // 春节[citation:1]
      '2025-01-28',
      '2025-01-29',
      '2025-01-30',
      '2025-01-31',
      '2025-02-01',
      '2025-02-02',
      '2025-02-03',
      '2025-02-04',
      // 清明节[citation:1]
      '2025-04-04',
      '2025-04-05',
      '2025-04-06',
      // 劳动节[citation:1]
      '2025-05-01',
      '2025-05-02',
      '2025-05-03',
      '2025-05-04',
      '2025-05-05',
      // 端午节[citation:1]
      '2025-05-31',
      '2025-06-01',
      '2025-06-02',
      // 国庆节、中秋节[citation:1]
      '2025-10-01',
      '2025-10-02',
      '2025-10-03',
      '2025-10-04',
      '2025-10-05',
      '2025-10-06',
      '2025-10-07',
      '2025-10-08',
    ];
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < day) {
      // 将日期向前推进一天
      result.setDate(result.getDate() + 1);

      // 检查当前日期是否为周末 (周六=6, 周日=0)
      const dayOfWeek = result.getDay();
      // 将日期转换为YYYY-MM-DD格式的字符串，用于比对
      const dateString = result.toISOString().split('T')[0];

      // 如果当前日期不是周末，也不在节假日列表中，则算作一个有效工作日
      if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holidays2025.includes(dateString)) {
        addedDays++;
      }
    }
    // 获取当前日期（去除时间部分，只比较日期）
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    // 判断是否超期
    const isOverdue = result < today;
    if (!isOverdue) {
      html += '<span style="display:inline-block;color:#00ff00">正常</span>';
    } else {
      if (
        step === '登簿' ||
        step === '缮证' ||
        step === '发证' ||
        step === '归档' ||
        step === '已完成' ||
        step === '驳回'
      ) {
        html += '<span style="display:inline-block;color:#00ff00">正常</span>';
      } else {
        html += '<span style="display:inline-block;color:red;">已超期</span>';
      }
    }
    return html;
  },

  ywly(ywh) {
    if (!ywh) {
      return '--';
    }
    if (ywh.startsWith('WW')) {
      return '网上服务大厅';
    } else if (ywh.startsWith('WG-DY')) {
      return '公积金购房';
    } else if (ywh.startsWith('WG-JY')) {
      return '公积金结清';
    } else {
      return '--';
    }
  },

  sfcq(day) {
    console.log('day', day);
    console.log('dayType', typeof day);
    if (day == 1) {
      return '<span style="display:inline-block;color:#00ff00">正常</span>';
    } else {
      return '<span style="display:inline-block;color:red;">已超期</span>';
    }
  },
  //获取预约事项
  getYssx(params) {
    return request({
      url: REST_SERVICE.define.getSubFlowDefConfig,
      method: 'get',
      params,
    });
  },
  //将获取的预审事项 arrayData接口获取的预审事项 去重
  arrangeYssx(arrayData) {
    let array = [];
    if (arrayData.length > 0) {
      let obj = {};
      for (let i = 0; i < arrayData.length; i++) {
        if (!obj[arrayData[i].name]) {
          array.push(arrayData[i]);
          obj[arrayData[i].name] = true;
        }
      }
      for (let item of array) {
        item.label = item.name;
        item.value = item.name;
      }
    }
    return array;
  },
  //获取文件列表
  getFileList(params) {
    return request({
      url: REST_SERVICE.files.getFileList,
      method: 'get',
      params,
    });
  },
  //设置文件夹全部展开
  unfold(fold) {
    fold.forEach((item) => {
      item.unfold = true;
    });
  },
  //获取上传的文件
  getUploadFile(params) {
    return request({
      url: REST_SERVICE.files.getUploadFile,
      method: 'post',
      data: params,
    });
  },
  //将文件放入文件夹内
  pushFile(fileFold, fileList) {
    fileList.forEach((pItem) => {
      fileFold.forEach((item) => {
        if (pItem.clfl === item.clmc) {
          if (!item.fileListData) {
            item.fileListData = [];
          }
          if (!pItem.fileUrl) {
            businessService.fileDetail(pItem);
          }
          let dataFormat = pItem.clmc.split('.');
          if (
            dataFormat[dataFormat.length - 1].toLowerCase() === 'jpg' ||
            dataFormat[dataFormat.length - 1].toLowerCase() === 'jpeg' ||
            dataFormat[dataFormat.length - 1].toLowerCase() === 'png'
          ) {
            pItem.dataFormat = 'img';
          }
          item.fileListData.push(pItem);
        }
      });
    });
    return fileFold;
  },
  fileDetail(pItem) {
    request({
      url: REST_SERVICE.files.viewUploadFile,
      method: 'get',
      fileId: pItem.fileId,
    }).then((res) => {
      if (res.success === true) {
        if (!res.data) {
          return;
        }
        let fileUrl = res.data.split('/');
        fileUrl.splice(0, 2);
        fileUrl[0] = window.CONFIG.UNIFY_IP.substring(window.CONFIG.UNIFY_IP.length - 1, 0);
        pItem.fileUrl = fileUrl.join('/');
      } else {
        this.$message.error(res.message);
      }
    });
  },
  //预审
  checkApply(params) {
    return request({
      url: REST_SERVICE.business.checkApply,
      method: 'post',
      data: params,
    });
  },
  bhWgSqxx(params) {
    return request({
      url: REST_SERVICE.business.bhWgSqxx,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      data: params,
    });
  },
  //备注延迟
  setDelay(params) {
    return request({
      url: REST_SERVICE.business.setDelay,
      method: 'post',
      data: params,
    });
  },
  // 上门揽件
  getPickUp(params, data) {
    return request({
      url: REST_SERVICE.ems.pickUp,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      params: params,
      data: data,
    });
  },
  // 获取保存的参数
  querySaveOrderInfo(params) {
    return request({
      url: REST_SERVICE.ems.querySaveOrderInfo,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      params,
    });
  },
  // 证书邮寄下单
  createOrderBySaveInfoId(params) {
    return request({
      url: REST_SERVICE.ems.createOrderBySaveInfoId,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      params,
    });
  },
  // 批量取号接口
  iwaybillBatch() {
    return request({
      url: REST_SERVICE.ems.iwaybillBatch,
      method: 'get',
    });
  },
  // 获取指定邮寄业务信息
  getOrdersById(params) {
    return request({
      url: REST_SERVICE.ems.getOrdersById,
      method: 'get',
      params,
    });
  },
  // 获取邮寄状态
  getEmsResult(params) {
    return request({
      url: REST_SERVICE.ems.getEmsResult,
      method: 'get',
      params,
    });
  },
  // 获取邮寄状态
  getTrace(params) {
    return request({
      url: REST_SERVICE.ems.getTrace,
      method: 'get',
      params,
    });
  },
  // 邮寄列表
  getOrdersByUserId(params) {
    return request({
      url: REST_SERVICE.ems.getOrders,
      method: 'get',
      params: params,
    });
  },
};
export default businessService;
